// toastHelpers.ts
import { URLSearchParamsInit } from "react-router-dom";
import { toast, ToastOptions } from "react-toastify";
import { ToastEventType } from "./types";

// Default options for all toasts
const defaultOptions: ToastOptions = {
    position: "bottom-center",  // default position
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    // Optionally, you can set a default theme here:
    theme: "light",
};

/**
 * showToast
 * Displays a toast message with the given type and message.
 * Accepts an additional options parameter to override defaults.
 */
export function showToast(
    type: ToastEventType,
    message: string,
    options?: ToastOptions
) {
    // Dismiss any existing toast if needed (optional)
    toast.dismiss();

    // Merge the default options with any overrides
    const toastOptions = { ...defaultOptions, ...options };


    switch (type) {
        case "success":
            toast.success(message, { ...toastOptions, icon: false, theme: "dark" } as ToastOptions);
            break;
        case "error":
            toast.error(message, toastOptions);
            break;
        case "info":
            toast.info(message, toastOptions);
            break;
        case "warning":
            toast.warning(message, toastOptions);
            break;
        default:
            toast(message, toastOptions);
    }
}

/**
 * handleToastFromUrl
 * Checks the searchParams for 'error' or 'message' and triggers a toast.
 * Resets searchParams after use to avoid repeated toasts.
 */
export function handleToastFromUrl(
    searchParams: URLSearchParams,
    setSearchParams: (nextInit?: URLSearchParamsInit) => void
) {
    const error = searchParams.get("error");
    const message = searchParams.get("message");

    if (error && message) {
        showToast("error", decodeURIComponent(message));
    } else if (message) {
        showToast("success", decodeURIComponent(message));
    }

    if (error || message) {
        // Clear them out so it doesn't toast again on refresh
        setSearchParams({});
    }
}